import React, { useEffect } from 'react';
import { IconX } from '../icon';
import './Toast.scss';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export type ToastMessage = {
    id: string;
    message: string;
    type: ToastType;
};

type ToastProps = {
    message: ToastMessage;
    onClose: (id: string) => void;
    duration?: number;
};

const Toast: React.FC<ToastProps> = ({ message, onClose, duration = 5000 }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose(message.id);
        }, duration);
        return () => clearTimeout(timer);
    }, [message.id, duration, onClose]);

    return (
        <div className={`toast toast--${message.type}`} onClick={() => onClose(message.id)}>
            <span className="toast__message">{message.message}</span>
            <button type="button" className="toast__close" aria-label="Close">
                <IconX size="sm" color="inherit" title="" />
            </button>
        </div>
    );
};

export default Toast;
